import { isEmpty, last } from 'lodash/fp'
import z, { ZodIssue } from 'zod'

const FormSchema = z.object({
    No1: z.enum(["不動産オーナーさま", "不動産管理会社さま", "家賃債務保証会社さま"], { message: "必須です" }),
    No2: z.enum(["法人", "個人"], { message: "必須です" }),
    No3: z.string().optional(),
    No4: z.string().optional(),
    No5: z.enum(["経営者・役員", "部長", "課長・次長", "係長・主任", "担当", "その他"]).optional(),
    No6: z.string().optional(),
    No7: z.string({ message: "必須です" }).min(1, "必須です"),
    No8: z.string({ message: "必須です" }).min(1, "必須です"),
    No9: z.string({ message: "必須です" }).min(1, "必須です").regex(/[0-9-]*/, { message: "半角数字とハイフンでご入力ください(例:090-1234-5678)" }),
    No10: z.string({ message: "必須です" }).min(1, "必須です"),
    No11: z.string({ message: "必須です" }).min(1, "必須です"),
    No12: z.enum(["インターネット検索", "メルマガ", "不動産管理会社の紹介", "家賃債務保証会社の紹介", "その他"], { message: "必須です" }),
    No13: z.enum(["打合せで説明を聞きたい", "説明資料の送付を希望します。", "両方", "その他"]).optional(),
    No14: z.string().optional(),
    No15: z.enum(["上記の個人情報保護基本方針について同意します"], { message: "必須です" }),
})

const CrossCheckSchema = z.object({
    No1: z.enum(["不動産オーナーさま", "不動産管理会社さま", "家賃債務保証会社さま"]).optional(),
    No2: z.enum(["法人", "個人"]).optional(),
    No3: z.string().optional(),
    No4: z.string().optional(),
    No5: z.enum(["経営者・役員", "部長", "課長・次長", "係長・主任", "担当", "その他"]).optional(),
    No6: z.string().optional(),
    No7: z.string().optional(),
    No8: z.string().optional(),
    No9: z.string().optional(),
    No10: z.string().optional(),
    No11: z.string().optional(),
    No12: z.enum(["インターネット検索", "メルマガ", "不動産管理会社の紹介", "家賃債務保証会社の紹介", "その他"]).optional(),
    No13: z.enum(["打合せで説明を聞きたい", "説明資料の送付を希望します。", "両方", "その他"]).optional(),
    No14: z.string().optional(),
    No15: z.enum(["上記の個人情報保護基本方針について同意します"]).optional(),
}).superRefine((data, ctx) => {
    if (!isEmpty(data.No2) && ["法人"].includes(data.No2) && isEmpty(data.No3)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `法人・個人 が "法人" のときは必須です`,
            path: ["No3"],
        })
    }
    if (!isEmpty(data.No2) && ["個人"].includes(data.No2) && isEmpty(data.No6)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `法人・個人 が "個人" のときは必須です`,
            path: ["No6"],
        })
    }
    if (!isEmpty(data.No13) && ["その他"].includes(data.No13) && isEmpty(data.No14)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `お問合せ内容 が "その他" のときは必須です`,
            path: ["No14"],
        })
    }
})

export const FormInputSchema = z.intersection(FormSchema, CrossCheckSchema)

const adjustIssue = (issue: ZodIssue, data: any): any => {
    const { path } = issue
    let resultItem = data
    for (const item of path.slice(0, -1)) {
        resultItem = resultItem[item]
    }
    resultItem[last(path) as string] = ''
    return data
}

export const adjustData = (issues: ZodIssue[], data: any): any => {
    let result = data
    for (const issue of issues) {
        const { code } = issue
        if (code === 'invalid_union') {
            const { unionErrors } = issue
            for (const unionError of unionErrors) {
                const { issues } = unionError
                for (const issue of issues) {
                    result = adjustIssue(issue, result)
                }
            }
        }
        if (code === 'invalid_type') {
            result = adjustIssue(issue, result)
        }
    }
    return result
}
